import { graphql } from 'react-relay';

export const adSlot = graphql`
  query adSlotQuery($placementType: PlacementType!, $workingPlatform: String, $target: String!, $utm: UtmInput) {
    getAdSlot(placementType: $placementType, platform: $workingPlatform, target: $target, utm: $utm) {
      result
      errors {
        code
        message
      }
      title
      placementType
      items {
        _id: id
        creativeType
        displayCode
        displayRatio
        userEvent
        ... on TextImageButtonAdSlotItem {
          displayTitle
          description
          imagePath
          buttonText
          linkUrl
        }
        ... on TextImageAdSlotItem {
          displayTitle
          description
          imagePath
          linkUrl
        }
        ... on TextButtonAdSlotItem {
          displayTitle
          description
          buttonText
          linkUrl
        }
      }
    }
  }
`;
